import React, { Component } from 'react';

import FormErrors from "./FormErrors";
import Validate from "./FormValidation";
import { Auth } from 'aws-amplify';
import { withRouter } from "react-router-dom";
import AbsoluteWrapper from "./AbsoluteWrapper";
import { Link } from 'react-router-dom';

import MainPage          from './pictures/MainTable.PNG' ;
import idms_console      from './pictures/idms_dashboard.PNG' ; //Trade_History
import LoginSlideshow    from  './dashboard/LoginSlideshow' ; //Trade_History



import store from "./store";






//_______________________________________

var AWS = require("aws-sdk");

let awsConfig = {
    "region": "us-west-2",
    "endpoint": "http://dynamodb.us-west-2.amazonaws.com",
    "accessKeyId": "", "secretAccessKey": ""
};

AWS.config.update(awsConfig);

let docClient = new AWS.DynamoDB.DocumentClient();


var userProfile ;

class Login extends Component {

  constructor(props) {
    super(props);

    //userProfile =  props.auth.user.userProfile;
  
    //this.handleSubmit = this.handleSubmit.bind(this);

  }



    state = {
      username: "",
      password: "",
      submitted: false,
      isAuthenticated : false,
      showing : false,

      userProfile : "",

      step : "new_signIn" ,

      activationCode : "" ,

      installationLimit:3,

      installations:[],

  
      errors: {
        cognito: null,
        blankfield: false
      }
    };
  
    clearErrorState = () => {
      this.setState({
        errors: {
          cognito: null,
          blankfield: false
        }
      });
    };



async  getUserFromAPI_Lambda_Dynamo(userId) {

    const res = await fetch(
      `https://q1qplrjos6.execute-api.us-west-2.amazonaws.com/check-access/check-access?username=${userId}`
    );

    const data = await res.json();

    

    if (data.access) {
      // access user
      this.props.history.push("/stock-picks"); 

       console.log(data);
    }

    else if (!data.access) {
      console.log(data);
      // block user
      alert("Trial expired / payment required");
    }


}

async  getUserFromDynamo(userId) {


   const params = {
      TableName: "idms-aws-db",

      Key: {
         email: userId
      }
   };

   try{

    const result = await docClient.get(params).promise();

    if(!result.Item ){

        console.log('User not found');

        this.setState({loading: false, message: 'User not found' }); 

        return;
    }

    //success----------------------

    this.setState({ loading:false, userData: result.Item, message:'Success'}); 


  

    this.props.history.push("/Dashboard"); 

    //----------trialEnd Dynamo Logic-----------------------

    /*if (Date.now() > new Date(result.Item.trialEnd)) {

           this.setState({loading: false,  message: 'User not found' }); 

           this.props.history.push("/login"); 
    }

    //-------------------------------//-------------------------------
    else if (Date.now() < new Date(result.Item.trialEnd)) {

         this.props.history.push("/stock-picks"); 
    }*/

  //-------------------------------


}
catch(error){

   console.log(error);

   /*
      DYNAMODB ERROR
   */

   this.setState({

      loading:false,

      message:
         error.message

   });

}

   //return result.Item;
}



    handleSubmit = async event => {
      event.preventDefault();
      //console.log('spinner is showing: ' + this.state.showing);
  
  
      this.setState({showing : true});
  
      // Form validation
  
      await this.clearErrorState();
  
      const error = Validate(event, this.state);
      if (error) {
        this.setState({
          errors: { ...this.state.errors, ...error }
        });
      }
  
      // AWS Cognito integration here
      try {

        const user = await Auth.signIn(this.state.username,this.state.password )

        const appUsername = user.attributes.preferred_username;


        const attributes = user.attributes;

        store.setUser(attributes);


        

        console.log(attributes);

        console.log("username : "+ appUsername);
  
        this.setState({isAuthenticated:true});
  
        //console.log(user); 
        console.log('user: ' + JSON.stringify(attributes));

        this.setState({step : "dashboard"}) ;


        //this.props.auth.setAuthStatus(true);

        //this.props.auth.setUser(user);


        //Test the expiry date----------------------from the database---and allow or reject access

              //this.getUserFromDynamo(this.state.username);

             this.props.history.push("/user_dashboard"); 

              //this.getUserFromAPI_Lambda_Dynamo(appUsername)

              // this.props.history.push("/stock-picks"); 


      }catch(error){
        console.log('error: ' + JSON.stringify(error));
  
        //console.log('this.state.isAuthenticated: ' + this.state.isAuthenticated);
  
        /*if(this.state.isAuthenticated === true && JSON.stringify(error) === "{}" ) {
                      this.setState({showing : false});
                      this.props.history.push("/stock-picks"); 
                      
        }*/
  
        if(this.state.isAuthenticated === false) {
                   this.setState({showing : false});
                   this.props.history.push("/login"); 
                  
        }
  
        let err = null;
        !error.message ? err = {"message": error} : err = error;
        this.setState({
          errors:{
            ...this.state.errors,
            cognito:err
          }
        })
  
      }




    };



    downloadEA = async () => {

        try {

            const session =
                await Auth.currentSession();

            const token =
                session.getIdToken().getJwtToken();


                 //console.log("token  : " + JSON.stringify(token, null, 2));    


            const response =
                await fetch(
                    "https://jtt8y195dj.execute-api.us-west-2.amazonaws.com/beta/download-bot",
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

            const data =
                await response.json();

                 console.log("data  : " + JSON.stringify(data, null, 2));    

            window.location.href =
                data.downloadUrl;

                this.setState({activationCode : data.activationCode}) ;
                this.setState({downloadUrl    : data.downloadUrl}) ;

                //console.log("this.state.activationCode ......  : " + JSON.stringify(this.state.activationCode, null, 2));    

        } catch (error) {

            console.error(error);
            alert("Download failed.");

        }
    };
    



    copyActivationCode = () => {

    navigator.clipboard.writeText(
        this.state.activationCode
    );


    alert("Activation code copied!");

};



  
    myFunction() {
      this.props.history.push("/dashbord"); 
    };
    
  
    onInputChange = event => {
      this.setState({
        [event.target.id]: event.target.value
      });
      document.getElementById(event.target.id).classList.remove("is-danger");
    };


componentDidMount() {
  
      //document.addEventListener('click', this.handleClick, true);
      
      this.setState({showing : false});
      this.setState({isAuthenticated:false});
      this.setState({
        errors: {
          cognito: null,
          blankfield: false
        }
      })   

      this.setState({userProfile:userProfile});

      

}


componentWillUnmount() {
       //document.removeEventListener('click', this.handleClick, true);
}




    //<Link to="/register" className="btn btn-link"> Click here create new iDMS account</Link>

    render() {

        var divStyle = {
           color: 'cyan',
           fontSize : "15px"
        }


    

      return (


    <AbsoluteWrapper>


        {this.state.step === 'new_signIn' && (

    <section className="row justify-content-center align-items-center vh-100 m-0 bg-light">
        
       <article className="col-10 col-lg-10 col-xl-10 h-100 p-5">

         <div className="card shadow border-0 h-100 overflow-hidden">

            <div className="card-body  mainCard_baground">

                <div className="row d-flex align-items-stretch g-0">

                    {/* Left Side */}


                    <div className="col-lg-6 h-100 position-relative">

                          <img src="./pictures/images_12.jpg"  width= "100%"  height= "180px"></img>
                           <br></br>

              

              <div className="navbar-brand "  id="inline1"></div>



                        {/*<h2 className="mb-4">
                            iDMS Trading Intelligence Platform
                        </h2>

                        <p className="lead">
                            Access your cloud-based trading intelligence
                            platform with real-time AI signals, professional
                            charting, market analytics and automated trading
                            tools.
                        </p>

                        <button className="btn btn-primary btn-lg mt-3">
                            Open Trading Platform
                        </button>*/}





                         <div className="management-console-header">

                            <h1>
                                iDMS
                                <span> Management Console</span>
                            </h1>

                            <p>
                                Secure administration portal for platform management,
                                user approvals, licensing and trading infrastructure.
                            </p>

                        </div>


                <div className="wrapper-line-login"></div>
                        <FormErrors formerrors={this.state.errors} />
                <br></br>

                    <div>
                                <p className="root-aut">  Root Client Login</p>
                    </div>
                    <br></br>


                    <form    href="/"  onSubmit={this.handleSubmit} >
                    <div className="field" >
                    <p className="control">
                        <input 
                        className="loginInput field-login" 
                        type="text"
                        id="username"
                        aria-describedby="usernameHelp"
                        placeholder="Enter email"
                        value={this.state.username}
                        onChange={this.onInputChange}

                        />
                        {this.state.submitted && !this.state.password &&
                                    <div className="help-block">Password is required</div>
                        }

                    </p>
                    </div>
                    <br></br>
            
                    <div className="field" >
                    <p className="control has-icons-left">
                        <input 
                        className="loginInput field-login" 
                        type="password"
                        id="password"
                        placeholder="Password"
                        value={this.state.password}
                        onChange={this.onInputChange}
                        />

                        {this.state.submitted && !this.state.username &&
                            <div className="help-block">Username is required</div>
                        }

                        <span className="icon is-small is-left">
                        <i className="fas fa-lock"></i>
                        </span>
                    </p>
                    </div>

                    <div>
                                            <Link to="/changepassword" className="btn-link change-password">Change password?</Link>
                    </div>


                    <div >
                        <Link to="/forgotpassword" className="btn-link forgot-password">Forgot password?</Link>
                    </div>

                
                    <br></br>

                
                    {/*<div className="login-button-2" >
                        <button className="login-button-3">
                        Login
                        </button>
                    </div>*/}



                    <button className="login-button-3">
                        <span className="login-icon"> &nbsp; &nbsp; 🔐 </span>

                        <span className="login-text">
                            Secure Login
                        </span>

                        <span className="login-arrow">
                            →
                        </span>
                    </button>

                 

                    </form>

                    <br></br>
                    <div>
                                            
                         <a className="btn btn-link link-center" href="http://idms-firm-filali.com.s3-website-us-west-2.amazonaws.com/" target="_blank" rel="noopener noreferrer">Not a member yet? Click here create new iDMS account</a>
                    </div>









                    </div>

                    {/* Right Side */}


                    <div className="col-lg-5 pt-5 px-5 pb-0 bg-light"    >


                        {/*<img
                            src={idms_console}
                             height= "900px" width="100%"
                            alt="iDMS Platform"
                            className="img-fluid platform-console-image"
                        />*/}

                        <LoginSlideshow   />

                    </div>


                </div>

            </div>
        </div>

    </article>
</section>



        )}


        {this.state.step === 'signIn' && (

            <section className="row justify-content-center text-center p-5">
                <article className="col-md-10">


                <div className="card p-1 m-1 shadow">

                    <div className="card-body">
                    

                     <img src={idms_console}    height= "400px" width="100%"></img>

                    <br></br>
                    <br></br>

                <div className="navbar-brand "  id="inline1">
                </div>

                <div className="wrapper-line-login"></div>
                <br></br>
                        <FormErrors formerrors={this.state.errors} />
                <br></br>

                    <div>
                                <p className="btn-link root-aut"><img src="./images_12.jpg"  width= "5%"  height= "5%"  alt="idms login"></img> &nbsp; &nbsp;   &nbsp; &nbsp;  Root Client Login</p>
                    </div>
                    <br></br>
                    <br></br>


                    <form    href="/"  onSubmit={this.handleSubmit} >
                    <div className="field" >
                    <p className="control">
                        <input 
                        className="loginInput field-login" 
                        type="text"
                        id="username"
                        aria-describedby="usernameHelp"
                        placeholder="Enter email"
                        value={this.state.username}
                        onChange={this.onInputChange}

                        />
                        {this.state.submitted && !this.state.password &&
                                    <div className="help-block">Password is required</div>
                        }

                    </p>
                    </div>
                    <br></br>
            
                    <div className="field" >
                    <p className="control has-icons-left">
                        <input 
                        className="loginInput field-login" 
                        type="password"
                        id="password"
                        placeholder="Password"
                        value={this.state.password}
                        onChange={this.onInputChange}
                        />

                        {this.state.submitted && !this.state.username &&
                            <div className="help-block">Username is required</div>
                        }

                        <span className="icon is-small is-left">
                        <i className="fas fa-lock"></i>
                        </span>
                    </p>
                    </div>

                    <div>
                                            <Link to="/changepassword" className="btn-link change-password">Change password?</Link>
                    </div>


                    <div >
                        <Link to="/forgotpassword" className="btn-link forgot-password">Forgot password?</Link>
                    </div>

                
                    <br></br>
                    <br></br>
                    <br></br>
                
                    <div className="login-button-2" >
                        <button className="login-button">
                        Login
                        </button>
                    </div>

                    </form>


                    <div>
                                            
                        <a className="btn btn-link" href="http://idms-firm-filali.com.s3-website-us-west-2.amazonaws.com/" target="_blank" rel="noopener noreferrer">Not a member yet? Click here create new iDMS account</a>
                    </div>

                    <br></br>
                    <br></br>


                    
                    </div>
                </div>
                </article>
                
            </section>

            )}


             {this.state.step === 'dashboard1' && (

                 <div className="admin-layout">

                {/* MAIN CONTENT */}
                  <div className="admin-main">

                    <div className="download-panel">

                        <h3>
                            MT5 Expert Advisor
                        </h3>

                        <p>
                            Download the latest iDMS MT5 Expert Advisor
                            and connect it to your cloud account.
                        </p>

                        <ul>
                            <li>Version: 1.0.3</li>
                            <li>Updated: July 2026</li>
                            <li>Compatible: MT5</li>
                        </ul>

                        <button
                            onClick={this.downloadEA}
                            className="btn btn-primary"
                        >
                            Download EA
                        </button>

                          <br></br>
                           <br></br>

                           <button
                            className=" btn-secondary"
                        >
                            Activation code :
                        </button>&nbsp; &nbsp;<a> {this.state.activationCode}  </a>

                         <br></br>
                          <br></br>

                       <spam  style = {divStyle}> "Please copy the generated licencing code and past it in the allocated input when you drag the EA to the chart for installation."</spam>

                          <br></br>
                           <br></br>

                       <spam  style = {divStyle}> "Please add https://idms-invest.com to MetaTrader → Tools → Options → Expert Advisors → Allow WebRequest."</spam>

                    </div>




                </div>

            </div>


            )}


 {this.state.step === 'dashboard2' && (

<div className="activation-card">

    <div className="activation-header">
        <h3>iDMS MT5 EA Activation</h3>
        <span className="status pending">
            Waiting for Activation
        </span>
    </div>


    <div className="activation-content">

        <p className="description">
            Your iDMS EA activation code has been created.
            Copy this code and enter it when you attach the EA to MetaTrader 5.
        </p>


        <div className="code-box">

            <label>
                Activation Code
            </label>

            <div className="code-row">

                <span className="activation-code">
                    ACT-8F7A93D2
                </span>

                <button className="copy-btn">
                    Copy
                </button>

            </div>

        </div>


        <div className="action-buttons">

            <button className="download-btn">
                Download MT5 EA
            </button>

        </div>


        <div className="instructions">

            <h4>Installation Steps</h4>

            <ol>
                <li>Download the iDMS MT5 EA package.</li>
                <li>Extract the downloaded ZIP file.</li>
                <li>Copy the EA file into MetaTrader 5 Experts folder.</li>
                <li>Restart MetaTrader 5.</li>
                <li>Drag iDMS EA onto your chart.</li>
                <li>Enter your activation code.</li>
            </ol>

        </div>

    </div>

</div>


 )}



 {this.state.showActivation &&
(
<div className="activation-overlay">

    <div className="activation-modal">

        <h2>
            iDMS MT5 EA Activation
        </h2>


        <p>
            Your activation code has been created.
        </p>


        <div className="activation-code">

            {this.state.activationCode}

        </div>


        <button
            onClick={this.copyActivationCode}
        >
            Copy Code
        </button>


        <a
          href={this.state.downloadUrl}
          className="download-btn"
        >
            Download MT5 EA
        </a>


    </div>

</div>
)}




{this.state.step === 'dashboard4' && (

<div className="admin-layout">

    <div className="admin-main">

        <div className="download-panel">


            {/* HEADER */}
            <div className="panel-header">

                <div>
                    <h3>
                        iDMS MT5 Expert Advisor
                    </h3>

                    <p className="subtitle">
                        Automated Trading Intelligence connected
                        to your iDMS cloud account.
                    </p>
                </div>


                <span className="version-badge">
                    v1.0.3
                </span>

            </div>



            {/* EA INFORMATION */}
            <div className="ea-info-card">

                <div>
                    <span>File : </span>
                    <strong>iDMS_EA.ex5</strong>
                </div>


                <div>
                    <span>Platform :</span>
                    <strong>MetaTrader 5</strong>
                </div>


                <div>
                    <span>Version : </span>
                    <strong>1.0.3</strong>
                </div>


                <div>
                    <span>Updated : </span>
                    <strong>July 2026</strong>
                </div>

            </div>


                          <br></br>



            {/* DOWNLOAD BUTTON */}
            <button
                onClick={this.downloadEA}
                className="download-button"
            >
                Download iDMS EA
            </button>

            
                          <br></br>




            {/* ACTIVATION CODE */}
            {this.state.activationCode && (

            <div className="activation-card">


                <h4>
                    Your EA Activation Code
                </h4>


                <p>
                    Copy this code and enter it when
                    you attach the iDMS EA to your MT5 chart.
                </p>


                <div className="activation-row">


                    <div className="activation-code">

                        {this.state.activationCode}

                    </div>


                    <button
                        className="copy-button"
                        onClick={this.copyActivationCode}
                    >
                        Copy
                    </button>


                </div>


                <div className="activation-status">

                    Status:
                    <span>
                        Waiting for Activation
                    </span>

                </div>


            </div>

            )}




            {/* INSTALLATION GUIDE */}
            <div className="installation-guide">


                <h4>
                    Installation Guide
                </h4>

                <br/>


                <ol>

                    <li>
                        Click <b>Download iDMS EA</b>.
                    </li>
                      <br/>


                    <li>
                        Open MetaTrader 5.
                    </li>

                      <br/>


                    <li>
                        Select:
                        <br/>
                        <b>
                        File → Open Data Folder
                        </b>
                    </li>

                      <br/>


                    <li>
                        Copy:
                        <br/>
                        <b>
                        iDMS_EA.ex5
                        </b>
                        <br/>
                        into:
                        <br/>
                        <b>
                        MQL5 → Experts → Advisors
                        </b>
                    </li>

                      <br/>


                    <li>
                        Restart MetaTrader 5.
                    </li>
                      <br/>


                    <li>
                        Drag iDMS EA onto your chart.
                    </li>

                    <br/>


                    <li>
                        Enter your activation code.
                    </li>

                    <br/>


                </ol>


            </div>



            {/* WEBREQUEST WARNING */}
            <div className="webrequest-box">


                <strong>
                    Required MT5 Permission
                </strong>


                <p>
                    Add iDMS server permission in MetaTrader 5:
                </p>


                <p>
                    MT5 → Tools → Options →
                    Expert Advisors →
                    Allow WebRequest
                </p>


                <code>
                    https://idms-invest.com
                </code>


            </div>


        </div>

    </div>

</div>

)}


{this.state.step === 'dashboard' && (




<div className="dashboard-container">


    {/* Welcome */}
    <div className="welcome-card">

        <h2>
            Welcome back, {this.state.username}
        </h2>

        <p>
            Access your iDMS trading intelligence platform.
        </p>

    </div>



    {/* Main Actions */}
    <div className="dashboard-grid">


        {/* LIVE TRADING */}
        <div className="dashboard-card">

            <h3>
                Live Trading Platform
            </h3>

            <p>
                Access real-time market intelligence,
                signals, charts and alerts.
            </p>


            <button
                className="live-button"
                onClick={this.openTrading}
            >

                Open Live Trading

            </button>

            <br></br>
            <br></br>
            <a href="http://admin.idms-invest.com.s3-website-us-west-2.amazonaws.com/" target="_blank" rel="noopener noreferrer">

                      <img 
                          src={MainPage} 
                          width="100%" 
                          alt="iDMS"
                      />

            </a>
             <br></br>  

        </div>




        {/* MT5 EA */}
        <div className="dashboard-card">


            <h3>
                MT5 Expert Advisor
            </h3>


            <p>
                Download and activate your iDMS MT5 EA.
            </p>


            <button
                className="download-button"
                onClick={this.downloadEA}
            >

               Download EA - iDMS_EA.ex5

            </button>


           {this.state.activationCode && (

<div className="ea-activation-panel">


    <div className="activation-header">

        <h3>
            iDMS MT5 EA Activation
        </h3>

        <span className="status-new">
            Waiting for Activation
        </span>

    </div>



    <p>
        Your activation code has been generated.
        Copy this code and enter it when attaching
        iDMS EA to your MetaTrader 5 chart.
    </p>



    {/* ACTIVATION CODE */}

    <div className="activation-code-box">


        <div>

            <label>
                Activation Code
            </label>


            <strong>
                {this.state.activationCode}
            </strong>

        </div>


        <button
            onClick={this.copyActivationCode}
        >
            Copy
        </button>


    </div>





    {/* DOWNLOAD */}

    <button
        className="download-button"
    >
       MT5 Installation Instructions
    </button>





    {/* INSTALLATION */}

    <div className="installation-section">




        <ol>

            <li>
                Download <b>iDMS_EA.ex5</b>.
            </li>


            <li>
                Open MetaTrader 5.
            </li>


            <li>
                Go to :
                <br/>
                <b>
                 &nbsp; File → Open Data Folder
                </b>
            </li>


            <li>
                Open :
                <br/>
                <b>
                 &nbsp; MQL5 → Experts → Adviser
                </b>
            </li>


            <li>
                Copy :
                <br/>
                <b>
                 &nbsp;iDMS_EA.ex5
                </b>
                 &nbsp; into this folder.
            </li>


            <li>
                Restart MetaTrader 5.
            </li>


            <li>
                Drag iDMS EA onto your chart.
            </li>


            <li>
                Enter the activation code.
            </li>


        </ol>


    </div>





    {/* WEB REQUEST */}

    <div className="webrequest-box">


        <h4>
            Required MT5 Permission
        </h4>


        <p>
            Add iDMS server permission in MetaTrader 5:
        </p>


        <p>
            MT5 → Tools → Options → Expert Advisors
            → Allow WebRequest
        </p>


        <code>
            https://idms-invest.com
        </code>


    </div>


</div>

)}

        </div>


    </div>





    {/* Intelligence */}
    <div className="dashboard-card intelligence-card">


        <h3>
            Trading Intelligence
        </h3>


        <div className="stats-row">


            <div>
                <span>
                    Signals
                </span>

                <strong>
                    Active
                </strong>
            </div>


            <div>
                <span>
                    Market
                </span>

                <strong>
                    NASDAQ
                </strong>
            </div>


            <div>
                <span>
                    AI Engine
                </span>

                <strong>
                    Online
                </strong>
            </div>


        </div>


    </div>



<div className="dashboard-card">

    <h3>Trading Intelligence</h3>

    <div className="license-summary">

        <span>Plan</span>
        <strong>{this.state.subscriptionType}</strong>

    </div>

    <div className="license-summary">

        <span>AI Engine</span>
        <strong className="online">
            Online
        </strong>

    </div>

    <div className="license-summary">

        <span>Active Installations</span>

        <strong>

            {this.state.installations.length} / 3

        </strong>

    </div>

    <table className="installation-table">

        <thead>

            <tr>

                <th>Symbol</th>

                <th>TF</th>

                <th>MT5</th>

                <th>Broker</th>

                <th>Status</th>

                <th></th>

            </tr>

        </thead>

        <tbody>

        {

        this.state.installations.map(item=>(

            <tr key={item.installationId}>

                <td>{item.symbol}</td>

                <td>{item.timeframe}</td>

                <td>{item.mt5Account}</td>

                <td>{item.broker}</td>

                <td>

                    <span className="status-active">

                        Active

                    </span>

                </td>

                <td>

                    <button

                        className="deactivate-button"

                        onClick={()=>

                        this.deactivateInstallation(item.installationId)

                        }

                    >

                        Deactivate

                    </button>

                </td>

            </tr>

        ))

        }

        </tbody>

    </table>

</div>




</div>


)}

    </AbsoluteWrapper>
   
  );
};


}

export default withRouter(Login);



//Since your platform is growing, I'd organize your endpoints like this:
/*https://api.idms-invest.com

/users

/activation

/heartbeat

/signals

/download

/admin

/feedback

/license

/installations */

//uggested production subdomains

//Since iDMS is becoming a complete ecosystem, a clean structure would be:

/*| Purpose           | URL                                |
| ----------------- | ---------------------------------- |
| Marketing website | `https://www.idms-invest.com`      |
| Trading platform  | `https://app.idms-invest.com`      |
| API               | `https://api.idms-invest.com`      |
| Administration    | `https://admin.idms-invest.com`    |
| Documentation     | `https://docs.idms-invest.com`     |
| Downloads         | `https://download.idms-invest.com` |
*/